module.exports = __webpack_public_path__ + "img/11_004.85a826e7.webp";